import global from './Globals';

export default {
  menuBgColour: global.qfb1,
  menuItemActive: global.qfb7,
  menuItemColour: global.white,
  menuItemHover: global.qfb7Fade,
  menuButtonColour: global.white,

  menuDivider: global.qfb1Fade,
  menuShadow: '5px 5px 10px #1f1f1f, -5px -5px 10px #252525;',

  menuDropdownBg: '#ffffff',
  menuDropdownText: global.black,
  menuDropdownTextHover: global.qfb7,
  menuDropdownTextActive: global.qfb7,

  menuMobileBg: global.qfb2,
  menuMobileWidth: '200px',
  menuHamburgerColor: global.white,
  menuHamburgerColorActive: global.white,
};
